import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output, TemplateRef } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';

export interface TellentMobileSheetOption {
  id: string;
  label: string;
  destructive?: boolean;
  disabled?: boolean;
}

export interface TellentMobileSheetOptionIconContext {
  $implicit: TellentMobileSheetOption;
}

@Component({
  selector: 'tlm-options-sheet',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TranslatePipe],
  templateUrl: './options-sheet.component.html',
  styleUrl: './options-sheet.component.less',
})
export class TellentMobileOptionsSheetComponent {
  public readonly title = input('');
  // Hides the title in the bottom-sheet presentation and shows it only when
  // the presenter displays the sheet as a centered dialog (tablets).
  public readonly dialogOnlyTitle = input(false);
  public readonly closeLabelKey = input('common.close');
  public readonly optionGroups = input.required<TellentMobileSheetOption[][]>();
  // Domain-specific headers (avatars, statuses) and per-option icons stay in the
  // host app; templates keep this component free of app icon/avatar components.
  public readonly headerTemplate = input<TemplateRef<unknown>>();
  public readonly iconTemplate = input<TemplateRef<TellentMobileSheetOptionIconContext>>();
  // Callback alternative to the `selected` output for hosts that present this
  // component through an overlay controller, where output bindings are unavailable.
  public readonly selectHandler = input<(option: TellentMobileSheetOption) => void>();
  public readonly dismissHandler = input<() => void>();

  public readonly selected = output<TellentMobileSheetOption>();
  public readonly dismissed = output<void>();

  protected select(option: TellentMobileSheetOption): void {
    this.selected.emit(option);
    this.selectHandler()?.(option);
  }

  protected dismiss(): void {
    this.dismissed.emit();
    this.dismissHandler()?.();
  }
}
